<template>
  <v-card flat color="transparent">
    <!-- toolbar with selector -->
    <v-toolbar color="transparent" flat height="55" dense>
      <v-toolbar-title class="pa-0 ml-n1 text--secondary subtitle-1 font-weight-medium">
        {{ dashboard ? dashboard.name : 'Mi Dashboard' }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items v-if="dashboardsList.length">
        <v-row align="center" justify="center" class="mr-1" style="min-width: 280px;">
          <v-select :value="selectedId" :items="dashboardOptions" item-text="name" item-value="id" outlined dense hide-details label="Fijar dashboard personalizado" background-color="white" @change="handleSelect" :disabled="saving" />
        </v-row>
      </v-toolbar-items>
    </v-toolbar>

    <!-- empty: no dashboards exist for the account -->
    <v-row v-if="!loading && !dashboardsList.length">
      <v-col cols="12" class="px-0 py-16 text-center">
        <v-icon color="secondary" size="70">mdi-view-dashboard-outline</v-icon>
        <span class="d-block subtitle-1 mt-3">Aún no tienes dashboards personalizados.</span>
        <v-btn class="mt-5" :to="{ name: 'Dashboards' }" outlined color="secondary" height="34">
          Crear nuevo dashboard
        </v-btn>
      </v-col>
    </v-row>

    <!-- empty: dashboards exist but none selected -->
    <v-row v-else-if="!loading && !selectedId">
      <v-col cols="12" class="px-0 py-16 text-center">
        <v-icon color="secondary" size="70">mdi-pin-outline</v-icon>
        <span class="d-block subtitle-1 mt-3">Aún no has elegido un dashboard personalizado.</span>
        <span class="d-block body-2 text--secondary mt-1">Selecciona uno arriba para mostrarlo aquí.</span>
      </v-col>
    </v-row>

    <!-- empty: selected dashboard has no metrics -->
    <v-row v-else-if="dashboard && (!dashboard.layout || !dashboard.layout.length)">
      <v-col cols="12" class="px-0 py-16 text-center">
        <v-icon color="secondary" size="70">mdi-view-dashboard-outline</v-icon>
        <span class="d-block subtitle-1 mt-3">Este dashboard aún no tiene métricas.</span>
        <span class="d-block body-2 text--secondary mt-1">Edítalo desde la herramienta de dashboards para agregarlas.</span>
      </v-col>
    </v-row>

    <!-- read-only grid -->
    <v-col v-else-if="dashboard" class="pt-0 px-0" cols="12">
      <grid-layout :layout.sync="readOnlyLayout" :col-num="12" :row-height="30" :is-draggable="false" :is-resizable="false" :vertical-compact="true" :margin="[15, 20]" :use-css-transforms="false">
        <grid-item v-for="item in readOnlyLayout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
          <template v-if="item.metrics.type.name === 'kpi'">
            <metric-kpi :metric="item.metrics.name" :interval="item.metrics.interval" :comparative="item.metrics.comparative" :draggable="false" :removable="false" />
          </template>
          <template v-else-if="item.metrics.type.name === 'graph'">
            <metric-graph :metric="item.metrics.name" :draggable="false" :removable="false" :resizable="false" :settings="{i: item.i, w: item.w}" />
          </template>
          <template v-else-if="item.metrics.type.name === 'table'">
            <metric-table :metric="item.metrics.name" :draggable="false" :removable="false" :resizable="false" :settings="{i: item.i, w: item.w}" />
          </template>
        </grid-item>
      </grid-layout>
    </v-col>
  </v-card>
</template>
<script>
import { GridLayout, GridItem } from 'vue-grid-layout'
import cloneDeep from 'lodash/cloneDeep'
import MetricKpi from '@/components/reports/MetricKpi'
import MetricGraph from '@/components/reports/MetricGraph'
import MetricTable from '@/components/reports/MetricTable'

export default {
  components: {
    GridLayout,
    GridItem,
    MetricKpi,
    MetricGraph,
    MetricTable
  },
  data: () => ({
    saving: false,
    loading: true
  }),
  computed: {
    settings () {
      return this.$store.state.accountSettings.settings
    },
    selectedId () {
      return this.settings && this.settings.default_dashboard
    },
    dashboard () {
      const detail = this.$store.state.dashboards.dashboardsDetail
      return detail && detail.id === this.selectedId ? detail : null
    },
    dashboardsList () {
      return this.$store.state.dashboards.dashboardsList || []
    },
    dashboardOptions () {
      return [{ id: null, name: 'Sin selección' }, ...this.dashboardsList]
    },
    readOnlyLayout () {
      if (!this.dashboard || !this.dashboard.layout) return []
      return cloneDeep(this.dashboard.layout)
    }
  },
  created () {
    Promise.all([
      this.$store.dispatch('accountSettings/RETRIEVE'),
      this.$store.dispatch('dashboards/LIST', { resource: 'metrics/dashboards', loader: false })
    ])
      .then(() => {
        if (this.selectedId) return this.fetchDashboard(this.selectedId)
      })
      .catch(() => {})
      .finally(() => { this.loading = false })
  },
  methods: {
    fetchDashboard (id) {
      return this.$store.dispatch('dashboards/RETRIEVE', {
        resource: 'metrics/dashboards',
        id,
        loader: false
      }).catch(() => {})
    },
    handleSelect (id) {
      this.saving = true
      this.$store.dispatch('accountSettings/UPDATE', { default_dashboard: id })
        .then(() => {
          if (id) return this.fetchDashboard(id)
        })
        .catch(() => {})
        .finally(() => { this.saving = false })
    }
  }
}
</script>
